
import Vue, { PropType } from 'vue';
import { get } from 'lodash';
import Api from '@/core/api';
import IconButton from '@/common/icon-button/IconButton.vue';
import { Icon } from '@/common/icon/Icon.vue';
import { Unsubscriber } from '@/core/event-bus';
import { PlayerState } from '@/core/player-state';

export default Vue.extend({
    components: {
        IconButton
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        isLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    },

    data() {
        return {
            isVideoElementFullScreen: false,
            unsubscribers: [] as Unsubscriber[]
        };
    },

    computed: {
        icon(): Icon {
            return this.isVideoElementFullScreen ? Icon.minimize : Icon.maximize;
        }
    },

    watch: {
        isVideoElementFullScreen: {
            immediate: true,
            handler() {
                this.api.customAction({ isFullScreen: this.isVideoElementFullScreen }, 'fullscreen');
            }
        }
    },

    mounted() {
        const { unsubscriber, state } = this.api.onStateChange(
            (partial: Partial<PlayerState>) => {
                this.isVideoElementFullScreen = get(partial, 'isVideoElementFullScreen', this.isVideoElementFullScreen);
            }
        );

        this.isVideoElementFullScreen = get(state, 'isVideoElementFullScreen', this.isVideoElementFullScreen);

        this.unsubscribers.push(unsubscriber);
    },

    beforeDestroy() {
        for (const unsubscriber of this.unsubscribers) {
            if (typeof unsubscriber === 'function') {
                unsubscriber();
            }
        }
    },

    methods: {
        toggleFullScreen() {
            if (this.isVideoElementFullScreen) {
                this.api.exitFullScreen();
            } else {
                this.api.enterFullScreen();
            }
        }
    }
});
